import { defineStore } from 'pinia'
import { ref, computed, Ref } from 'vue'
import { accountApi } from '@services/account.service'
import { User as UserClass } from './user/user'

declare global {
  interface Window {
    isAuthenticated: string | number
  }
}

export const useAuthStore = defineStore('authStore', () => {
  const loading: Ref<boolean> = ref(false)
  const doctorId: Ref<string> = ref(null)
  const user = ref(new UserClass({}, false))

  const isAuthenticated = computed(() => user.value.isAuthenticated())
  const isDetermined = computed(() => user.value.determined)
  const profileType = computed(() => user.value?.info?.profileType)

  function setUser(newUser: UserClass): void {
    user.value = newUser
    if (user.value?.info) {
      const { doctorIds: [firstDoctorId] = [null] } = user.value.info
      doctorId.value = firstDoctorId
    }
  }
  function updateUser(data: { [key: string]: unknown }): void {
    user.value = new UserClass({ ...user.value.info, ...data })
  }
  function setLoading(value: boolean): void {
    loading.value = value
  }
  function initialReceive() {
    if (user.value.determined) {
      return null
    }
    return lockedReceive()
  }
  function lockedReceive(): Promise<void> | null {
    if (loading.value) {
      return null
    }

    return receive()
  }
  async function receive(): Promise<void> {
    setLoading(true)

    return await accountApi.retrieve.execute()
      .then(({ item = {} }) => {
        setUser(new UserClass(item))
      })
      .catch((error: Response) => {
        setUser(new UserClass({}))
        console.warn(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  function patch(payload: Record<string, any>) {
    return accountApi.update.execute({}, payload)
      .then(({ data: { item = {} } = {} }) => {
        updateUser(item)
        return item
      })
  }

  return {
    loading,
    user,
    profileType,
    isAuthenticated,
    isDetermined,
    doctorId,
    setUser,
    updateUser,
    setLoading,
    initialReceive,
    lockedReceive,
    receive,
    patch,
  }
})
